import ReactMarkdown from 'react-markdown';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import remarkGfm from 'remark-gfm';
import MarkdownMediaLoader from 'client/components/aria/MarkDown/MarkdownMediaLoader/MarkdownMediaLoader';
import styles from './Markdown.module.scss';
import { Link } from 'react-router';

const Markdown = ({ children, ...props }) => {
    return <div className={[styles.container, props.className].filter(Boolean).join(' ')} {...props}>
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
                img ({ src, alt }) {
                    return <MarkdownMediaLoader src={src} alt={alt} />;
                },
                h1 ({ node, ...props }) {
                    return <h1 data-testid="markdown.h1" {...props} />;
                },
                a ({ node, href, ...props }) {
                    const resolvedHref = href && href.startsWith('/webportal')
                        ? href.replace(/^\/webportal/, '')
                        : href;

                    if (resolvedHref && resolvedHref.startsWith('/') && !resolvedHref.startsWith('//')) {
                        return <Link to={resolvedHref} {...props} />;
                    }

                    return <a href={resolvedHref} {...props} />;
                }
            }}
            data-testid={props['data-testid']}
        >
            {children}
        </ReactMarkdown>
    </div>;
};

Markdown.propTypes = {
    ...defaultAriaProps
};

export default Markdown;
